import { render, staticRenderFns } from "./PackageListAdd.vue?vue&type=template&id=9afc3c3a&scoped=true&"
import script from "./PackageListAdd.vue?vue&type=script&lang=js&"
export * from "./PackageListAdd.vue?vue&type=script&lang=js&"
import style0 from "./PackageListAdd.vue?vue&type=style&index=0&id=9afc3c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afc3c3a",
  null
  
)

export default component.exports